import { useEffect } from "react";
import {
  StyledInnerPopup_Small,
  StyledOuterPopup,
} from "../../../styles/components/Popup.styled";

// Shared chrome for the feature's dialogs: the app's standard overlay and small card,
// plus the three behaviors every dialog here needs. Built on the app's existing popup
// primitives so these look like every other dialog in the app.
export function ModalShell(props: {
  onClose: () => void;
  children: React.ReactNode;
}) {
  const { onClose } = props;

  // Escape closes, matching what people expect of a dialog.
  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        onClose();
      }
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [onClose]);

  // Keep the page behind the overlay from scrolling, the way MyItems does for its forms.
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  return (
    <StyledOuterPopup
      // Clicking the backdrop closes; mousedown on the card must not count.
      onMouseDown={(event: React.MouseEvent) => {
        if (event.target === event.currentTarget) {
          onClose();
        }
      }}
    >
      <StyledInnerPopup_Small>{props.children}</StyledInnerPopup_Small>
    </StyledOuterPopup>
  );
}
